module.exports = __webpack_public_path__ + "img/demigods-page_900.1cbfec7e.png";